/*
ashraf  10/10/2022 2700520533_2698849438 fixed role based access, client maintenance edit rate popup issues
Suresh Peddavoora 10/30/2022 2700520533_2698849438  Modified styles for dashboard header
Raghu 11/14/2022 2700520533_2698849438 Card Style Fixes
*/
import React, {useContext, useEffect} from 'react';
import LandingPage from '../../LandingPage';
import {useHistory} from 'react-router';
import {useSelector} from 'react-redux';
import ParentClientTable from './ParentClientTable';
import {ThemeContext} from '../../../themes/ThemeProvider';

const ParentForm = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes1 = reusableInputStyles();
  const history = useHistory();

  const {roleData} = useSelector(({role}) => role);

  useEffect(() => {
    if (roleData &&
     Object.keys(roleData) &&
     roleData?.window &&
     !roleData?.window?.['Client Maintenance']?.PC?.read) {
      history.replace('/account-summary');
    }
  }, [roleData]);
  return (
    <>
      <LandingPage showTabs={true}>
        <div className="global-field-dash-board">
          {/* <Button
            className={`${classes.dashboard}`}
            variant="text"
            onClick={() => {
              history.push("/client-search");
            }}
          >
            <ArrowBack className="mr-2" />
            BACK TO DASHBOARD
          </Button> */}
          <div className={`${classes1.cardBordernoneStyles} rounded `}>
            <ParentClientTable />
          </div>
        </div>
      </LandingPage>
    </>
  );
};

export default ParentForm;
